import React, { Component } from "react";

class AuthVenvers extends Component {
    constructor(props) {
        super(props);
        const hasConnection =
            props.personVenvers && props.personVenvers.length > 0;
        const existingApiKey = hasConnection
            ? props.personVenvers[0].api_key
            : "";
        this.state = {
            showModal: false,
            apiKey: existingApiKey,
            responseMessage: null,
            responseType: null, // 'success' | 'error'
            isConnected: hasConnection,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleConnect = this.handleConnect.bind(this);
        this.startUpdate = this.startUpdate.bind(this);
        this.handleDisconnect = this.handleDisconnect.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.personVenvers !== this.props.personVenvers) {
            const hasConnection =
                this.props.personVenvers && this.props.personVenvers.length > 0;
            const existingApiKey = hasConnection
                ? this.props.personVenvers[0].api_key
                : "";

            this.setState({
                apiKey: existingApiKey,
                isConnected: hasConnection,
            });
        }
    }

    openModal() {
        this.setState({ showModal: true, responseMessage: null, responseType: null });
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    handleChange(e) {
        this.setState({ apiKey: e.target.value });
    }

    handleConnect() {
        axios
            .post("/api/venvers/validate", {
                api_key: this.state.apiKey,
            })
            .then((res) => {
                const { valid, reason } = res.data;

                this.setState(
                    {
                        responseMessage:
                            reason || (valid ? "API Key válida" : "API Key inválida"),
                        responseType: valid ? "success" : "error",
                        isConnected: !!valid,
                    },
                    () => {
                        if (valid) {
                            window.location.reload();
                        }
                    }
                );
            })
            .catch((err) => {
                let message = "Ocurrió un error al conectar con Venvers";
                if (err.response && err.response.data) {
                    if (typeof err.response.data === "string") {
                        message = err.response.data;
                    } else if (err.response.data.error) {
                        message = err.response.data.error;
                    } else if (err.response.data.reason) {
                        message = err.response.data.reason;
                    }
                }

                this.setState({
                    responseMessage: message,
                    responseType: "error",
                });
            });
    }

    startUpdate() {
        this.setState({
            isConnected: false,
            apiKey: "",
            responseMessage: null,
            responseType: null,
        });
    }

    handleDisconnect() {
        swal
            .fire({
                title: "¿Estás seguro?",
                text: "¿Estás seguro de eliminar la conexión con Venvers?",
                icon: "warning",
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-light-primary",
                    cancelButton: "btn font-weight-bold btn-light",
                },
            })
            .then((result) => {
                if (!result.isConfirmed) {
                    return;
                }

                axios
                    .post("/api/venvers/disconnect")
                    .then((res) => {
                        console.log(res);
                        window.location.reload();
                    })
                    .catch((err) => {
                        console.error(err);
                        swal.fire({
                            title: "Error",
                            text: "Ocurrió un error al eliminar la conexión con Venvers",
                            icon: "error",
                            buttonsStyling: false,
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton:
                                    "btn font-weight-bold btn-light-primary",
                            },
                        });
                    });
            });
    }

    render() {
        const { isConnected } = this.state;
        return (
            <>
                <div className="card card-custom gutter-b h-100" style={{ border: '1px solid #E4E6EF', borderRadius: 14, boxShadow: 'none' }}>
                    <div className="card-body p-7">
                        <div className="d-flex align-items-center justify-content-between mb-6">
                            <span className="font-weight-bolder font-size-lg text-dark">Venvers</span>

                            <span className="badge" style={{ background: isConnected ? '#ECFDF5' : '#F3F4F6', borderRadius: 9999, padding: '8px 16px' }}>
                                <span
                                    className="d-inline-block mr-2"
                                    style={{ width: 10, height: 10, borderRadius: 9999, background: isConnected ? '#10B981' : '#D1D5DB', verticalAlign: 'middle' }}
                                ></span>
                                <span className="font-weight-bold" style={{ color: isConnected ? '#059669' : '#9CA3AF' }}>{isConnected ? 'Conectado' : 'No conectado'}</span>
                            </span>
                        </div>

                        <div className="d-flex align-items-start justify-content-between">
                            <img src="/assets/img/venvers.webp" alt="Venvers" style={{ height: 32, width: 'auto' }} />

                            <div className="d-flex flex-column align-items-end">
                                {!isConnected && (
                                    <button type="button" className="btn btn-primary font-weight-bolder" onClick={this.openModal}>
                                        <i className="fa fa-link mr-2" style={{ fontSize: 12 }}></i>
                                        Conectar
                                    </button>
                                )}

                                {isConnected && (
                                    <button
                                        type="button"
                                        className="btn font-weight-bolder"
                                        style={{ background: '#FFFFFF', border: '1px solid #E4E6EF', color: '#8950FC' }}
                                        onClick={this.handleDisconnect}
                                    >
                                        <i className="fa fa-unlink mr-2" style={{ fontSize: 12, color: '#8950FC' }}></i>
                                        Desconectarme
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.showModal && (
                    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Conectar Venvers</h5>
                                    <button type="button" className="close" onClick={this.closeModal}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label>API Key</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={this.state.apiKey}
                                                onChange={this.handleChange}
                                                placeholder="Ingresa tu API Key"
                                            />
                                        </div>

                                        {this.state.responseMessage && (
                                            <div
                                                className={
                                                    this.state.responseType === "success"
                                                        ? "alert alert-success mt-3"
                                                        : "alert alert-danger mt-3"
                                                }
                                                role="alert"
                                            >
                                                {this.state.responseMessage}
                                            </div>
                                        )}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-light-primary" onClick={this.closeModal}>
                                            Cerrar
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={this.handleConnect}
                                        >
                                            Conectar
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default AuthVenvers;
